import { EPermissoes } from '@/enums/ePermissoes';
import utlTipoFornecimentoService from '@/services/utilidade/utl-tipo-fornecimento.service';

export default [
  {
    description: 'Cadastro de Cabos',
    path: 'cabos',
    name: 'cabos',
    component: () => import('@/views/utilidade/produto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Cabo',
    path: 'incluir',
    name: 'cabosinsert',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'cabos',
      utlTipoFornecimentoId: 206,
      campos: () => utlTipoFornecimentoService.getCamposProduto(206),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Inclusão de Cabo',
    path: 'incluir/:id',
    name: 'cabosinsertcopy',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'cabos',
      utlTipoFornecimentoId: 206,
      campos: () => utlTipoFornecimentoService.getCamposProduto(206),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Edição de Cabo',
    path: 'editar/:id',
    name: 'cabosupdate',
    component: () => import('@/views/utilidade/produto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'cabos',
      utlTipoFornecimentoId: 206,
      campos: () => utlTipoFornecimentoService.getCamposProduto(206),
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Fornecedor de Cabos',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-cabos',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Unidade de Cabos',
    path: 'unidade',
    name: 'unidadecabos',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Cabos',
    path: 'unidade/incluir',
    name: 'inclusaounidadecabos',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadecabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade Cabos',
    path: 'unidade/editar/:id',
    name: 'unidadecabosupdate',
    meta: {
      parentRouteName: 'unidadecabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Unidade Tipo Cabos',
    path: 'unidade-tipo',
    name: 'unidadetipocabos',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra],
      ambienteRouteName: 'ambientecabos',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Unidade Tipo Cabos',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipocabosinsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipocabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo Cabos',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipocabosupdate',
    meta: {
      parentRouteName: 'unidadetipocabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambientecabos',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambientecabosinsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientecabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambientecabosupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambientecabos',
      tipoFornecimento: 'cabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Tipo Ensaio de Cabos',
    path: 'tipo-ensaio',
    name: 'tipoensaiocabos',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Tipo Ensaio Cabos',
    path: 'tipo-ensaio/incluir',
    name: 'tipoensaiocabosinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo Ensaio Cabos',
    path: 'tipo-ensaio/editar/:id',
    name: 'tipoensaiocabosupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiocabos',
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.CadastroObra]
    }
  }
];
